import React, { useEffect, useLayoutEffect, useState } from 'react';
import InventoryListDumb from './InventoryListDumbOLD';
import queryString from 'query-string';
import { withRouter, useHistory } from 'react-router-dom';
import { useUser, useList, useInventory } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import { Alert, ModalAlert, ErrorScreen } from 'components/common';
import withRequest from 'hoc/withRequest';
import { ROUTES } from 'consts';

const InventoryListSmarOLDt = (props) => {
  const { parameters, filters, setFilters } = useUser();
  const projects = formatProjectItems(parameters);
  const projectsMap = projects.reduce((a, v) => ({ ...a, [v.value]: v}), {});
  const { getContentList, content, error, isLoaded } = useList('inventories');
  const inventory = useInventory();
  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [inventorySelected, setInventorySelected] = useState(null);
  let { project=filters.project } = queryString.parse(props.location.search);

  const handleListPage = () => {
    if (project !== filters.project) setFilters({ project });
    if (project && !!projectsMap[project]) {
      getContentList({
        query: {
          baseUrl: projectsMap[project].base_url
        },
      });
    } else history.push(`?project=${projects[0].value}`);
  };

  const handleCleanUp = () => {
    inventory.cleanUpMessage();
  }

  const handleSearch = (data) => {
    let routeToPush = `${ROUTES.INVENTORY_LIST}?project=${data.project}`;
    history.push(routeToPush);
  };

  const handleCreate = () => {
    handleCleanUp();
    history.push(ROUTES.INVENTORY_CREATE);
  };

  const handleEdit = (inventory) => {
    handleCleanUp();
    history.push(`${ROUTES.INVENTORY_EDIT}/${inventory.value}/${projectsMap[project].base_url}`);
  };

  const handleDelete = () => {
      const body = {
        baseUrl: projectsMap[project].base_url,
        f: inventorySelected.value
      }
    inventory.deleteInventory({ body });
    setOpenModal(false);
  };

  const handleModalDelete = (inventory) => {
    setInventorySelected(inventory);
    setOpenModal(true);
  };

  const alerts = [
    {
      severity: 'success',
      open: inventory.success.post,
      message: 'inventoryList.components.alert.success',
    },
    {
      severity: 'success',
      open: inventory.success.delete,
      message: 'inventoryList.components.alert.deleteSuccess',
    },
    {
      severity: 'info',
      open: inventory.success.put,
      message: 'inventoryList.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: inventory.error.put,
      message: 'inventoryList.components.alert.error',
    },
    {
      severity: 'error',
      open: inventory.error.delete,
      message: 'inventoryList.components.alert.error',
    },
    {
      severity: 'error',
      open: inventory.error.post,
      message: 'inventoryList.components.alert.error',
    },
  ];

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);

  useLayoutEffect(() => {
    if (filters.project) handleSearch({ project: filters.project });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      inventory.success.get ||
      inventory.success.post ||
      inventory.success.put ||
      inventory.success.delete
    ) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    inventory.success.get,
    inventory.success.post,
    inventory.success.put,
    inventory.success.delete,
  ]);

  return (
    <>
      { error ? (
        <ErrorScreen />
      ) : (
        <InventoryListDumb
          handleSearch={handleSearch}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          handleDelete={handleModalDelete}
          content={content}
          options={projects}
          isLoaded={isLoaded}
          defaultValues={{
            project: !project ? projects[0].value : project,
          }}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => inventory.cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={handleDelete}
      />
    </>
  );



}

export default withRequest(withRouter(InventoryListSmarOLDt));
